<template>
  <el-dialog
    title="开票记录"
    :visible.sync="visible"
    width="400px"
    @close="$emit('update:show', false)"
    @open="opened"
    :close-on-click-modal="false"
  >
    <el-form ref="form" label-width="100px" :model="model" :rules="formRules">
      <el-form-item label="开票金额" prop="amount">
        <el-input
          style="width: 220px"
          size="small"
          v-model="model.amount"
          placeholder="请输入费用金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="开票日期" prop="date">
        <el-date-picker
          size="small"
          v-model="model.date"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="开票抬头" prop="customer_invoice_id">
        <el-select
          size="small"
          v-model="model.customer_invoice_id"
          placeholder="请选择发票"
        >
          <el-option
            v-for="item in invoices"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开票文件">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :limit="1"
          accept=".png, .jpg, .jpeg, .pdf"
          :headers="uploadHeader"
          :file-list="fileList"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeUpload"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传.png,.jpg,.jpeg,.pdf文件，且不超过10M
          </div>
        </el-upload>
        <auth-img
          tag="el-image"
          v-if="model.id > 0 && model.file && model.file.length > 0"
          style="width: 60px; height: 60px"
          :src="host + model.file"
          :fit="fit"
        ></auth-img>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submiting" @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  createCustomerInvoice,
  updateCustomerInvoice,
  customerOrderList,
  createCustomerCollection,
  updateOrderCost,
  createOrderCost,
  updateInvoiceRecord,
  customerInvoiceList,
  createInvoiceRecord,
} from '../service/getData'
import { urlPerfix, host } from '@/config/env'
import store from '@/store/store'
import { clone } from '@/util'
import { getStore } from '@/config/storage'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    customerOrderID: {
      type: Number,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
    model() {},
  },
  data() {
    return {
      host,
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      fileList: [],
      invoices: [],
      formRules: {
        amount: [
          { required: true, message: '请输入开票金额', trigger: 'change' },
        ],
        date: [
          { required: true, message: '请输入开票日期', trigger: 'change' },
        ],
      },
      submiting: false,
    }
  },
  created() {},
  methods: {
    opened() {
      if (this.invoices.length == 0) {
        this.requestCustomerInvoices()
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          this.model.amount = parseFloat(this.model.amount)
          if (this.model.id > 0) {
            let res = await updateInvoiceRecord(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createInvoiceRecord(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          return false
        }
      })
    },
    async requestCustomerInvoices() {
      let res = await customerInvoiceList({
        page: 0,
        size: 1000,
        customer_id: this.customerOrderID,
      })
      this.invoices = res.data.list
    },
    handleSuccess(res, file) {
      if (res.code == 0) {
        this.model.file = res.data
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 < this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(`文件大小不能超过 ${this.uploadLimitSize.file}MB!`)
      }
      return isLimitSize
    },
    handleRemove() {
      this.model.file = null
    },
  },
}
</script>